initsm();

function getsm () {
  return document.querySelectorAll('.spring-mark li a').length
}

function initsm () {
  var smlength = getsm();
  var pathposition = 0;
  for (let index = 1; index <= smlength; index++) {
    pathOnDiv(index.toString(), pathposition);
    pathposition += 1 / smlength;  
  }
}

function pathOnDiv(text: string, pos: any) {
   // Get the coordinates of the point that is the fraction 'pos' along the path
   var  path = (document.getElementById('numbers-path') as unknown) as SVGGeometryElement;
   var  pathLength = path.getTotalLength();
   var  loc = path.getPointAtLength(pos * pathLength);

   // Make a div
   var div = document.createElement("div");
   div.textContent = text;
   div.setAttribute("class", "pathDiv");
   div.style.left = loc.x + "px";
   div.style.top = loc.y + "px";
   document.getElementById('svg-path').appendChild(div);
}

// window.addEventListener('resize', () => {
//   var elements = document.querySelectorAll('.pathDiv').forEach(function(item, index) {
//     item.remove()
//   });

//   initsm();
// });
